import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Loader from '@/atoms/loader';

export interface ProcessingPaymentModalProps {
  visible: boolean;
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
  }
`;

const ProcessingPaymentModal = ({ visible }: ProcessingPaymentModalProps) => {
  const { t } = useTranslation();

  return visible ? (
    <StyledModal open={visible} footer={null} centered width="60%">
      <div className="flex flex-col items-center justify-center" style={{ padding: '100px' }}>
        <Loader />
        <div className="text-4xl font-bold mt-10">{t('booking.processingPaymentModal.title')}</div>
      </div>
    </StyledModal>
  ) : null;
};

export default ProcessingPaymentModal;
